import { IControl, Map } from "mapbox-gl";

export class MapBoxMapRefocusControl implements IControl {
  private _container: HTMLElement;
  private _map: Map;
  private _callback: () => void;

  constructor(callback: () => void) {
    this._callback = callback;
  }

  onAdd(map: Map): HTMLElement {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    this._container.innerHTML = `
      <button id="lockButton" class="mapboxgl-ctrl-icon maps-icon icon-center--circle" type="button" title="Refocus map"></button>
    `;

    this._container.querySelector('button')?.addEventListener('click', () => {
      this._callback();
    });

    return this._container;
  }

  onRemove(): void {
    this._container.parentNode?.removeChild(this._container);
    this._map = undefined!;
  }
}
